(function() {
  'use strict';
  angular.module('common')
  .filter('portalDate', ['$filter', function($filter) {
    let dateFilter = $filter('date');
    return function(val) {
      return dateFilter(val, 'M/d/yyyy');
    };
  }]);
})();